import React from 'react';
import { CustomerServiceWidget } from './widget';

export const CustomerServicePage: React.FC = () => <CustomerServiceWidget />;
